import React from 'react';

const VECIInstructions = () => (
  <div className='animate-slide-up'>
    <div className='card border-0 shadow-sm rounded-4 p-4 mb-4 bg-primary text-white'>
      <div className='d-flex align-items-center mb-0'>
        <div className='bg-opacity-20 p-3 rounded-4 me-3'>
          <i className='bi bi-info-circle display-6'></i>
        </div>
        <div>
          <h4 className='fw-bold mb-1'>Instruksi & Konteks Survey</h4>
          <p className='mb-0 opacity-75'>
            Harap baca seksama sebelum melanjutkan ke pengisian instrumen
          </p>
        </div>
      </div>
    </div>

    <div className='card border-0 shadow-sm rounded-4 p-4 p-md-5 mb-4 bg-white'>
      <h5 className='fw-bold mb-4 d-flex align-items-center'>
        <i className='bi bi-chat-left-text text-primary me-2'></i>
        Pesan untuk Collaborative Leaders
      </h5>
      <div className='p-4 bg-light rounded-4 border-start border-4 border-primary mb-4 lh-lg text-dark'>
        <p className='fw-bold mb-3'>Hi Collaborative Leaders!</p>
        <p className='mb-3'>
          Mohon lengkapi data survei VECI berikut secara objektif dan murni
          berdasarkan hasil wawancara Anda dengan pengurus BUMDes. Perlu
          ditegaskan bahwa skor akhir dari survei VECI ini sama sekali tidak
          memengaruhi penilaian kinerja maupun nilai akhir Anda dalam program
          ini. Oleh karena itu, harap isi setiap pertanyaan sejujur-jujurnya.
        </p>
        <p className='mb-3'>
          Keakuratan data ini sangat krusial untuk memetakan kondisi aktual
          BUMDes, yang selanjutnya akan menjadi landasan utama dalam merumuskan
          intervensi pengembangan daya saing yang paling tepat sasaran.
        </p>
        <p className='mb-0'>
          Terima kasih atas kerjasamanya. Selamat bertugas dan tetap semangat
          dalam memberikan dedikasi terbaik!
        </p>
      </div>

      <h5 className='fw-bold mb-4 mt-5 d-flex align-items-center'>
        <i className='bi bi-bar-chart-line text-primary me-2'></i>
        Keterangan Skala Jawaban
      </h5>
      <div className='table-responsive'>
        <table className='table table-borderless'>
          <thead>
            <tr className='text-muted small text-uppercase'>
              <th style={{ width: '80px' }}>Skala</th>
              <th>Keterangan (Dibanding Pesaing Terkuat)</th>
            </tr>
          </thead>
          <tbody>
            {[
              {
                v: 1,
                label: 'Sangat Buruk',
                desc: 'Sangat Buruk dibanding pesaing terkuat',
              },
              { v: 2, label: 'Buruk', desc: 'Buruk dibanding pesaing terkuat' },
              {
                v: 3,
                label: 'Setara',
                desc: 'Setara dibanding pesaing terkuat',
              },
              {
                v: 4,
                label: 'Lebih Baik',
                desc: 'Lebih Baik dibanding pesaing terkuat',
              },
              {
                v: 5,
                label: 'Sangat Baik',
                desc: 'Sangat Baik dibanding pesaing terkuat',
              },
            ].map((item) => (
              <tr
                key={item.v}
                className='align-middle'
              >
                <td className='py-3'>
                  <div
                    className='bg-primary text-white rounded-circle d-flex align-items-center justify-content-center fw-bold shadow-sm'
                    style={{ width: '40px', height: '40px' }}
                  >
                    {item.v}
                  </div>
                </td>
                <td className='py-3'>
                  <div className='fw-bold text-dark'>{item.label}</div>
                  <div className='text-muted small'>{item.desc}</div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default VECIInstructions;
